/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment-timezone';
import { EXERCISE_TYPE } from '../../../../../shared/constants';
import { saveCalendarExercise } from '../../../ducks/calendarActions';
/**
 * file for updating create exercise form validation and initial values and values to be submited
 based on type.
 */

const useCalendarAutoSaveCalendarItems = () => {
  const dispatch = useDispatch();
  const [isAdding, setIsAdding] = useState(false);
  const selectedDate = useSelector((state) => state.calendar.data.selectedDate);
  const currentUser = useSelector((state) => state.auth.data.currentUser);
  const calendarItems = useSelector((state) => state.calendar.data.calendarItems);

  const errorAddReset = () => {
    setIsAdding(false);
  };

  const getExerciseType = (itemToSave) => {
    if (itemToSave.type === EXERCISE_TYPE.Questionnaire) {
      return 'questionnaire';
    }
    if (itemToSave.type === EXERCISE_TYPE.WarmUp) {
      return 'warm_up';
    }
    if (itemToSave.type === EXERCISE_TYPE.Cooldown) {
      return 'cooldown';
    }
    if (itemToSave.type === EXERCISE_TYPE.Health) {
      return 'health';
    }
    if (itemToSave.type === EXERCISE_TYPE.Note) {
      return 'note';
    }
    if (itemToSave.type === EXERCISE_TYPE.Progression) {
      return 'progression';
    }
    if (itemToSave.type === EXERCISE_TYPE.Lift) {
      return 'lift';
    }
    if (itemToSave === EXERCISE_TYPE.SAQC) {
      return 'saq+c';
    }
    if (itemToSave === EXERCISE_TYPE.Circuit) {
      return 'circuit';
    }
    return '';
  };

  const handleAutoSaveCalendarItem = (
    itemToSave,
    setSubmitting = () => {},
    closeModal = () => {},
    contentIndexParam = null,
    submissionObjectToSave = null,
    formattedDateToSave = null,

  ) => {
    let submissionObject;
    setIsAdding(true);
    const setSubmissionArray = [];
    const defaultSubmissionObject = {
      date: moment(selectedDate).format('YYYY-MM-DD'),
      exerciseId: parseInt(itemToSave.id, 10),
      // type: 'questionnaire',
      type: getExerciseType(itemToSave),
      sets: setSubmissionArray,
      showSessionBreakItems: false,
    };
    if (itemToSave.description) {
      defaultSubmissionObject.description = itemToSave.description;
    }
    if (submissionObjectToSave) {
      submissionObject = submissionObjectToSave;
    } else {
      submissionObject = defaultSubmissionObject;
    }
    const saveDate = new Date(selectedDate);
    const formattedDate = formattedDateToSave || moment(saveDate).format('YYYY-MM-DD');
    /** if there is a passed content index param use that, else add to end of list */
    const newCalendarItemIndex = contentIndexParam || calendarItems[formattedDate]?.exercises?.length; /** length will be the index we want to give to the added item */
    dispatch(saveCalendarExercise(
      currentUser,
      newCalendarItemIndex,
      submissionObject,
      formattedDate,
      errorAddReset,
      {
        onSuccess: () => {
          setSubmitting(false);
          closeModal();
        },
        onError: () => {
          setSubmitting(false);
          closeModal();
        },
      },
    ));
  };

  return {
    handleAutoSaveCalendarItem,
  };
};

export default useCalendarAutoSaveCalendarItems;
